__turbopack_context__.v({
  "border--none": "eTaUXW_border--none",
  "borderColor--warning": "eTaUXW_borderColor--warning",
  "button": "eTaUXW_button",
  "colorScheme--muted": "eTaUXW_colorScheme--muted",
  "colorScheme--none": "eTaUXW_colorScheme--none",
  "container": "eTaUXW_container",
  "field": "eTaUXW_field",
  "icon": "eTaUXW_icon",
  "input": "eTaUXW_input",
  "isEmpty": "eTaUXW_isEmpty",
  "isListOpen": "eTaUXW_isListOpen",
  "modal": "eTaUXW_modal",
  "modalContent": "eTaUXW_modalContent",
  "multiselect": "eTaUXW_multiselect",
  "placeholder": "eTaUXW_placeholder",
  "requiredInput": "eTaUXW_requiredInput",
  "row": "eTaUXW_row",
  "selection": "eTaUXW_selection",
  "selectionRemove": "eTaUXW_selectionRemove",
  "selections": "eTaUXW_selections",
  "shadow--none": "eTaUXW_shadow--none",
  "showSelection": "eTaUXW_showSelection",
  "size--lg": "eTaUXW_size--lg",
  "size--sm": "eTaUXW_size--sm",
  "width--maxcontent": "eTaUXW_width--maxcontent",
  "wiggle--a": "eTaUXW_wiggle--a",
  "wiggle--b": "eTaUXW_wiggle--b",
});
